// type
import { FormDataType, MailContentItem } from '../typings/newsletter';
import { saveReqType, sendEmailReqType } from '@/api/newsletter/data.d';
import { InputEnum } from '@/definition/common/data.d';

/** 邮件内容 - 默认表单 */
export const defaultEmailContentItem: MailContentItem = {
  lang: '',
  /** 邮件主题 */
  subject: '',
  /** 模板 */
  templateId: 0,
  thumbnailUrl: '',
};

/** 默认表单 */
export const defaultForm: FormDataType = {
  /** 是否开启预约 */
  isTurnOn: false,
  /** 是否设置预约邮件 */
  isSettingEmail: false,
  /** 发送信息 */
  senderInfo: {
    /** 发件人 */
    name: '',
    /** 发件地址 */
    prefixAddress: '',
    /** 发件域名 */
    domain: '',
  },
  /** 发件人 */
  senderName: '',
  /** 发件地址 */
  prefixAddress: '',
  /** 发件域名 */
  domain: '',
  /** 邮件内容 - 默认语言 */
  defaultLang: 'en',
  /** 邮件内容 - 多语言 */
  emailContent: [],
  /** 邮件内容 - 多语言 */
  emailContents: [],
  /** 发送测试邮件 邮箱地址 */
  testSenderEmails: [],
};

// 提交保存指定字段 - 避免提交无效内容
export const subAppointReq: saveReqType = {
  isTurnOn: false,
  isSettingEmail: false,
  isDraft: false,
  senderInfo: {
    name: '',
    domain: '',
    prefixAddress: '',
  },
  defaultLang: '',
  emailContents: [],
  testSenderEmails: [],
};

// 提交发送测试邮件指定字段 - 避免提交无效内容
export const sendEmailAppointReq: sendEmailReqType = {
  senderInfo: {
    name: '',
    domain: '',
    prefixAddress: '',
  },
  defaultLang: '',
  emailContents: [],
  testSenderEmails: [],
};

export const emailContentsReq = {
  subject: '',
  template: 0,
};

// 预览发送人信息表单配置
export const previewPromptMappingTable = [
  {
    inputType: InputEnum.text,
    field: 'subject',
    labelKey: 'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.EMAIL.SUBJECT',
  },
  {
    inputType: InputEnum.text,
    field: 'from',
    labelKey: 'CONTACT.MANAGE.CREATE.NEWSLETTER.SETTING.EMAIL.FORM',
  },
];
